<input type="file" matInput class="file-input" [accept]="requiredFileType" [disabled]="disabled" (change)="onFileSelected($event)" #fileUpload />

<div class="file-upload">
    <div>
        <span class="me-2" style="color: rgba(0, 0, 0, 0.54);">{{ fileName || emptyFileMessage }}</span>

        <button mat-icon-button type="button" (click)="clear()" *ngIf="fileName">
            <mat-icon>cancel</mat-icon>
        </button>

        <button mat-mini-fab color="primary" [disabled]="disabled" (click)="fileUpload.value = null; fileUpload.click();">
            <mat-icon>attach_file</mat-icon>
        </button>
    </div>
</div>

<div>
    <mat-progress-bar class="progress-bar" mode="determinate" [value]="fileService.uploadProgress" *ngIf="fileService.uploadProgress !== null"></mat-progress-bar>
    <mat-icon class="cancel-upload" (click)="fileService.cancelUpload()" *ngIf="fileService.uploadProgress !== null">cancel</mat-icon>
</div>

<hr style="margin-top: .5rem; background-color: rgba(0, 0, 0, 0.87) !important;" />